import React, { FC, Fragment } from 'react';
import ContactSection from './contactSection';
import CheckboxSection from './checkboxSection';
import RadioSection from './radioSection';
import { TGDPRInlineProps, TGDPRPolicy } from '../../../../../../types/gdprConsentField.types';
import './styles.scss';

const GdprPolicyConsent: FC<TGDPRInlineProps> = (props) => {
    const { gdprPolicies, updateData, data, contactChecboxes, contactConsentDescriptionIndex } = props;

    const isAllRadioDisagreed = !!data.every((item) =>
        item.type === 'radio' ? item.accepted === false || item.accepted === undefined : true
    );

    return (
        <div className="gdpr-consent">
            {gdprPolicies.policies?.map((policy: TGDPRPolicy, index: number) => (
                <Fragment key={policy.id}>
                    {policy.type === 'checkbox' && index !== contactConsentDescriptionIndex && (
                        <CheckboxSection
                            policy={policy}
                            updateData={updateData}
                            checked={data?.find((item) => item.id === policy.id)?.accepted || false}
                        />
                    )}
                    {policy.type === 'radio' && (
                        <RadioSection policy={policy} updateData={updateData} accepted={data?.find((item) => item.id === policy.id)?.accepted} />
                    )}
                </Fragment>
            ))}
            <ContactSection
                contactChecboxes={contactChecboxes}
                updateData={updateData}
                textContent={contactConsentDescriptionIndex ? gdprPolicies.policies[contactConsentDescriptionIndex] : undefined}
                disabled={isAllRadioDisagreed}
                data={data}
            />
        </div>

    )
}

export default GdprPolicyConsent;